export function BAD_REQUEST_TIP(error: unknown, t: unknown) {
  console.log('BAD_REQUEST_TIP == ', error)
  if ((error as { response?: { data?: { message?: string } } })?.response?.data?.message === '已使用禁止刪除') {
    return (t as (key: string) => string)('Tips_Common.cannot_delete_use')
  } else if ((error as { response?: { data?: { message?: string } } })?.response?.data?.message === '不可刪除') {
    return (t as (key: string) => string)('Tips_Common.cannot_delete')
  } else if (
    (error as { response?: { data?: { message?: string } } })?.response?.data?.message === '存在預約禁止刪除'
  ) {
    return (t as (key: string) => string)('Tips_Common.cannot_delete_reservation')
  }
  return ''
}
